import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, makeStyles, Popover } from '@material-ui/core';
import { Play, Info } from 'components/icons';
import { usePartnerChecklist } from 'apps/getstarted/hooks';
import VideoModal from 'apps/getstarted/components/VideoModal';
import { TASKS } from '../constants';

const useStyles = makeStyles(theme => ({
  outlineBtn: {
    borderColor: 'var(--colorSystemInfo)',
    color: 'var(--colorSystemInfo)',
    minWidth: 110,
    height: 32,
    textTransform: 'none',
    fontSize: 14,
    '&:last-child': {
      marginLeft: 30
    },
    '&:hover': {
      backgroundColor: 'var(--colorSystemInfo)',
      color: 'var(--whiteAndBlack)'
    }
  },
  tooltip: {
    maxWidth: 400,
    padding: 16,
    color: 'var(--colorDefault)',
    '& p': {
      marginTop: 0
    }
  }
}));

const InfoButtons = ({ name }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const { loading, tasks } = usePartnerChecklist();
  const currentTask = TASKS.find(item => item.name === name);

  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end">
      <Button
        onClick={() => setOpenVideoModal(true)}
        variant="outlined"
        disableElevation
        className={classes.outlineBtn}
      >
        <Play mr={1.2} size={1.3} />
        Watch
      </Button>
      <Button
        onClick={e => setAnchorEl(e.currentTarget)}
        variant="outlined"
        disableElevation
        className={classes.outlineBtn}
      >
        <Info mr={1.2} size={1.3} />
        Explain
      </Button>

      <Popover
        id={anchorEl ? 'simple-popover' : undefined}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <div className={classes.tooltip}>
          <p>{currentTask?.title || ''}</p>
          <p>{currentTask?.getDescription() || ''}</p>
        </div>
      </Popover>

      <VideoModal
        open={openVideoModal}
        close={() => setOpenVideoModal(false)}
        title={currentTask?.title || ''}
        video={tasks[name]?.video_url || ''}
        loading={loading}
      />
    </Box>
  );
};

InfoButtons.propTypes = {
  name: PropTypes.string.isRequired
};

export default InfoButtons;
